import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Search } from "lucide-react";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState(params.get("q") || "");
  const category = params.get("category") || "";

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data.categories || []));
  }, []);

  useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams();
    if (category) qs.set("category", category);
    if (q) qs.set("q", q);
    api.get(`/products?${qs.toString()}`).then((r) => setProducts(r.data.products)).finally(() => setLoading(false));
  }, [category, q]);

  const setCategory = (c) => {
    const p = new URLSearchParams(params);
    if (c) p.set("category", c); else p.delete("category");
    setParams(p);
  };

  return (
    <div data-testid="products-page" className="max-w-7xl mx-auto px-6 py-12">
      <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// catalog</div>
      <h1 className="font-heading font-bold text-4xl md:text-5xl mt-2">All licenses</h1>

      <div className="mt-8 flex flex-col md:flex-row gap-4 md:items-center">
        <div className="relative w-full md:max-w-md">
          <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#71717A] pointer-events-none z-10" />
          <input
            data-testid="products-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="search software..."
            className="input-term"
            style={{ paddingLeft: "2.75rem" }}
          />
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            data-testid="filter-all"
            onClick={() => setCategory("")}
            className={`font-mono text-xs px-3 py-2 rounded-full border transition-colors ${!category ? "bg-[#00FF66] text-black border-[#00FF66]" : "border-[#1E293B] text-[#A1A1AA] hover:border-[#00FF66]"}`}
          >
            all
          </button>
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase()}`}
              onClick={() => setCategory(c)}
              className={`font-mono text-xs px-3 py-2 rounded-full border transition-colors ${category === c ? "bg-[#00FF66] text-black border-[#00FF66]" : "border-[#1E293B] text-[#A1A1AA] hover:border-[#00FF66]"}`}
            >
              {c.toLowerCase()}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-10">
        {loading ? (
          <div className="text-[#A1A1AA] font-mono">loading products...</div>
        ) : products.length === 0 ? (
          <div className="surface p-10 text-center">
            <div className="font-mono text-[#A1A1AA]">no products found</div>
            <Link to="/products" className="btn-ghost mt-4 inline-flex">Reset filters</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
